<template>
  <div :class="[baseCss, paddingOff ? null : 'p-2', `text-${align}`]" :style="{maxHeight, overflow: maxHeight ? 'auto' : 'visible'}">
    <slot />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'CardText',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('card-text', ['text-sm'])
    }
  },
  props: {
    paddingOff: {
      type: Boolean
    },
    maxHeight: {
      type: String
    },
    align: {
      type: String,
      default: 'auto',
      validator: value => {
        return ['left', 'center', 'right', 'justify', 'auto'].includes(value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/card-text/card-text.vue